/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Banner
 */
export interface Banner {
    /**
     * 
     * @type {number}
     * @memberof Banner
     */
    readonly id?: number;
    /**
     * 
     * @type {Date}
     * @memberof Banner
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Banner
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof Banner
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    image: string;
    /**
     * 
     * @type {string}
     * @memberof Banner
     */
    url?: string | null;
}

export function BannerFromJSON(json: any): Banner {
    return BannerFromJSONTyped(json, false);
}

export function BannerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Banner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'image': json['image'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function BannerToJSON(value?: Banner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'priority': value.priority,
        'title': value.title,
        'image': value.image,
        'url': value.url,
    };
}


